module.exports = __webpack_public_path__ + "img/defaulthead.d17ca756.png";